export const mapTemplateRecord = (item = {}) => ({
  id: item?.id || "--",
  name: item?.name || "--",
  category: item?.category || "--",
  language: item?.language || "--",
  bodyS3Key: item?.body_s3_key || "--",
  variables: item?.variables || {},
  isActive: Boolean(item?.is_active),
  createdBy:
    item?.created_by_details?.user_name ||
    item?.created_by_details?.email ||
    item?.created_by ||
    null,
  filePath: item?.file_path || null,
  fileName: item?.file_name || null,
  fileType: item?.file_type || null,
  fileSize: item?.file_size ? Number(item.file_size) : null,
  createdAt: item?.created_at || null,
  updatedAt: item?.updated_at || null,
  raw: item,
});
